import { Outlet } from 'react-router-dom'
import { MFEWrapper } from '@yuno/dashboard-container-mfe'

const MainLayout = () => (
  <MFEWrapper>
    <Outlet />
  </MFEWrapper>
)

export default MainLayout
